// Override Easy Discounts Table Styles - Match Theme Design System
document.addEventListener('DOMContentLoaded', function() {
  // Function to clean and style the discount table
  function styleDiscountTable() {
    // Find all Easy Discounts containers by ID pattern
    const discountContainers = document.querySelectorAll('[id*="easy-discounts-table"], div[id^="easy-discounts-table-"]');
    
    discountContainers.forEach(container => {
      const showDescription = false; // force OFF, không bao giờ render banner
      const descriptionText = window.Shopify && window.Shopify.theme && window.Shopify.theme.settings && window.Shopify.theme.settings.easy_discounts_table_description;
      
      if (showDescription !== false && !container.querySelector('.discount-table-description')) {
        const descriptionDiv = document.createElement('div');
        descriptionDiv.className = 'discount-table-description';
        descriptionDiv.style.marginBottom = '1rem';
        descriptionDiv.style.padding = '0.75rem';
        descriptionDiv.style.backgroundColor = '#f8f9fa';
        descriptionDiv.style.borderRadius = '4px';
        descriptionDiv.style.fontSize = '14px';
        descriptionDiv.style.color = '#333';
        descriptionDiv.style.textAlign = 'center';
        
        // Use text from theme settings or default
        descriptionDiv.textContent = descriptionText || 'MUA SỐ LƯỢNG LỚN ĐỂ NHẬN GIÁ ƯU ĐÃI';
        
        container.insertBefore(descriptionDiv, container.firstChild);
      }
      // Remove all inline styles from container
      container.removeAttribute('style');
      
      // Find the table inside
      const table = container.querySelector('table');
      if (!table) return;
      
      // Clean table inline styles
      table.removeAttribute('style');
      
      // Clean all elements inside table
      const allElements = table.querySelectorAll('*');
      allElements.forEach(el => {
        el.removeAttribute('style');
      });
      
      // Add theme classes if they don't exist
      if (!table.classList.contains('table')) {
        table.classList.add('table', 'table--sm', 'table--bordered');
      }
      
      // Ensure proper table structure
      let thead = table.querySelector('thead');
      let tbody = table.querySelector('tbody');
      
      // If no thead but has header row, create proper structure
      if (!thead && table.rows.length > 0) {
        const firstRow = table.rows[0];
        const hasHeaders = firstRow.cells[0] && (
          firstRow.cells[0].tagName === 'TH' ||
          firstRow.cells[0].textContent.includes('Min') ||
          firstRow.cells[0].textContent.includes('Qty')
        );
        
        if (hasHeaders) {
          thead = document.createElement('thead');
          const headerRow = firstRow.cloneNode(true);
          
          // Convert TD to TH if needed
          Array.from(headerRow.cells).forEach(cell => {
            if (cell.tagName === 'TD') {
              const th = document.createElement('th');
              th.textContent = cell.textContent;
              cell.replaceWith(th);
            }
          });
          
          thead.appendChild(headerRow);
          table.insertBefore(thead, table.firstChild);
          firstRow.remove();
        }
      }
      
      // Ensure tbody exists
      if (!tbody) {
        tbody = document.createElement('tbody');
        while (table.rows.length > (thead ? 1 : 0)) {
          tbody.appendChild(table.rows[thead ? 1 : 0]);
        }
        table.appendChild(tbody);
      }
      
      // Fix price formatting - remove extra ,000 from VND prices
      const allCells = table.querySelectorAll('td, th');
      allCells.forEach(cell => {
        const text = cell.textContent;
        // Check if cell contains VND price with wrong format
        if (text.includes('VND') && text.includes(',000 VND')) {
          // Remove the extra ,000 before VND
          cell.textContent = text.replace(/,000\s*VND/g, ' VND');
        }
      });
      
      // Translate column headers to Vietnamese
      const headerCells = table.querySelectorAll('thead th, thead td');
      headerCells.forEach(cell => {
        const text = cell.textContent.trim().toUpperCase();
        if (text === 'MIN QTY' || text === 'MIN' || text.includes('MIN')) {
          cell.textContent = 'Từ';
        } else if (text === 'MAX QTY' || text === 'MAX' || text.includes('MAX')) {
          cell.textContent = 'Đến';
        } else if (text === 'DISCOUNT' || text.includes('DISCOUNT')) {
          cell.textContent = 'GIẢM GIÁ';
        } else if (text === 'FINAL PRICE' || text === 'PRICE' || text.includes('FINAL') || text.includes('PRICE')) {
          cell.textContent = 'ĐƠN GIÁ';
        }
      })
    });
  }
  
  // Run immediately
  styleDiscountTable();
  
  // Run again after delays (for async loaded content)
  setTimeout(styleDiscountTable, 500);
  setTimeout(styleDiscountTable, 1500);
  setTimeout(styleDiscountTable, 3000);
  
  // Watch for DOM changes
  const observer = new MutationObserver(function(mutations) {
    let shouldRestyle = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && node.id && typeof node.id === 'string' && node.id.includes('easy-discounts-table')) {
            shouldRestyle = true;
          }
        });
      }
    });
    
    if (shouldRestyle) {
      setTimeout(styleDiscountTable, 100);
    }
  });
  
  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});